export default {
  Auth: {
    region: "us-west-2",
    userPoolId: "us-west-2_TtwWVpjWz",
    userPoolWebClientId: "54jaob4bingv1qna1u802n49c9",
    mandatorySignIn: true,
  },
};
